module.exports = __webpack_public_path__ + "img/tablista_snowboard.ae3525e5.png";